import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditOrgStructureAssignment from '../../components/orgStructureAssignments/FormAddEditOrgStructureAssignment';

const CreateOrgStructureAssignment = () => (<WrapperSection><GlobalBreadcrumbs /><FormAddEditOrgStructureAssignment /></WrapperSection>);
export default CreateOrgStructureAssignment;
